document.addEventListener("DOMContentLoaded", function() {
	$(document).ready(function(){
		if($("#flipdown").length > 0){
			let countdownTime = $(".countdown-time").text();
			var targetDate  = new Date(countdownTime);

			var flipdown = new FlipDown(targetDate.getTime() / 1000, {
				theme: "light",
			  }).start(); 
	
		}
		
		function checkScroll() {
			if ($(window).scrollTop() > 0) {
				$('body').addClass('scrolled');
			} else {
				$('body').removeClass('scrolled');
			}
		}
	
		$(window).on('scroll', checkScroll); 
		checkScroll();

		$("body").on("click",".menu-opener",function(){
			$(this).toggleClass('opened').prev('nav').toggleClass('opened');
		});


		if($(".is-style-header-notification").length > 0){
			$(".is-style-header-notification").append("<span></span>");

			let header_notification = $(".is-style-header-notification").clone();
			if($(window).width() < 992){
				$(".is-style-header-notification").hide();
				$(".header.wp-block-template-part").prepend(header_notification);
			
			}
			
			$("body").on("click", ".is-style-header-notification span", function(e){
				$(".is-style-header-notification").addClass("close");
			})
		}

		if($(".news").length > 0){
            $(".news").find('.wp-block-post').addClass('swiper-slide');
			
			$(".news_container").append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');

            new Swiper('.news_container', {
                speed: 400,
                spaceBetween: 15,
                slidesPerView: 1.1,
                autoHeight: false,
				
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				  },
                breakpoints: {
                    480: {
                        slidesPerView: 1.5
                    },
                    768: {
                        slidesPerView: 2.5
                    },
                    1200: {
                        slidesPerView: 3 
                    },
                }
            });
        } 

		if($(".is-style-carousel").length > 0){
            $(".is-style-carousel").find('.wp-block-column').addClass('swiper-slide');
            $(".is-style-carousel").append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');

            new Swiper('.is-style-carousel', { 
                speed: 400,
                spaceBetween: 25,
                slidesPerView: 1.8,
                autoHeight: true,
                navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				  },
                breakpoints: {
                    480: {
                        slidesPerView: 2.2
                    },
                    768: {
                        slidesPerView: 2.5
                    },
                    991: {
                        slidesPerView: 3.5
                    },
					1200: {
                        slidesPerView: 4
                    },
                }
            });
        }
	});	
});
